import { c as _c } from "react/compiler-runtime";
import { styled } from '@classify/react-core-components/styles';
import Skeleton from '@classify/react-core-components/Skeleton';
const PREFIX = 'LoadingSkeleton';
const classes = {
  item: `${PREFIX}-item`,
  text: `${PREFIX}-text`
};
const Root = styled('div')(/* istanbul ignore next */({
  theme: {
    spacing,
    palette
  }
}) => ({
  [`& .${classes.item}`]: {
    display: 'flex',
    padding: spacing(2, 1),
    overflow: 'hidden',
    '&:not(:last-child)': {
      borderBottom: `1px solid ${palette.layout.line.divider}`
    }
  },
  [`& .${classes.text}`]: {
    marginLeft: spacing(2)
  }
}));
export default function LoadingSkeleton() {
  const $ = _c(10);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Skeleton width="100px" height="18px" variant="rectangular" sx={{
      marginBottom: "24px",
      display: "block"
    }} />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div><Skeleton variant="circular" width="40px" height="40px" /></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Skeleton width="120px" height="18px" variant="rectangular" sx={{
      marginBottom: "8px",
      display: "block"
    }} />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className={classes.item}>{t1}<div className={classes.text}>{t2}<Skeleton width="240px" height="18px" variant="rectangular" sx={{
          display: "block"
        }} /></div></div>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div><Skeleton variant="image" width="40px" borderRadius="circle" /></div>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Skeleton width="100px" height="18px" sx={{
      marginBottom: "8px",
      display: "block"
    }} />;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className={classes.item}>{t4}<div className={classes.text}>{t5}<Skeleton width="210px" height="18px" sx={{
          display: "block"
        }} /></div></div>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div><Skeleton variant="image" width="40px" borderRadius="circle" /></div>;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <Skeleton width="80px" height="18px" sx={{
      marginBottom: "8px",
      display: "block"
    }} />;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <Root>{t0}{t3}{t6}<div className={classes.item}>{t7}<div className={classes.text}>{t8}<Skeleton width="260px" height="18px" sx={{
            display: "block"
          }} /></div></div></Root>;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  return t9;
}